module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"404","message":"We could not find the page you\u0027re looking for."},"ja":{"title":"404","message":"お探しのページは見つかりませんでした。"}}')
  delete Component.options._Ctor
}
